<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Message.CopyShippingMarkAndName')"
    width="1000px"
    :close-on-click-modal="false"
    append-to-body
    class="app-main-inner transcribe-dialog"
  >
    <div class="app-main-inner-row" style="padding-bottom: 20px;">
      <el-form label-width="70px" label-position="left" style="width: 100%">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_CustomerName')">
              <cargo-company-select
                :method-params="{customer:true}"
                :default-value="filter.customer"
                no="1"
                @change="p=>{filter.customer=p.value}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('queryJob.englishDescriptionOfGoods')">
              <el-input v-model="filter.cargoEnglishName" no="2" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('SeaExport.Marks')">
              <el-input v-model="filter.mark" no="3" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-button
              type="primary"
              no="4"
              @click="filter.pageNum=1;toQuery()"
            >{{ $t('CargoMsg.Cargo_Query') }}</el-button>
            <el-button type="primary" no="5" @click="reset">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="height: 300px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <cargo-pagination
      v-show="total>0"
      :total="total"
      :page.sync="filter.pageNum"
      :limit.sync="filter.pageSize"
      @pagination="toQuery"
    />
    <span slot="footer">
      <el-button
        type="primary"
        no="6"
        @click="choose(['cargoEnglishName','mark','hsCode'])"
      >{{ $t('SeaExport.SelecteAll') }}</el-button>
      <el-button
        type="primary"
        no="7"
        @click="choose(['cargoEnglishName'])"
      >{{ $t('CargoMsg.Cargo_EnglishCargoName') }}</el-button>
      <el-button type="primary" no="8" @click="choose(['mark'])">{{ $t('CargoMsg.Cargo_Marks') }}</el-button>
      <el-button type="primary" no="9" @click="choose(['hsCode'])">{{ $t('CargoMsg.Cargo_HsCode') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { Job } from '@/class/model/booking/Job'

export default {
  name: 'TranscribeDialog',
  components: { cargoCompanySelect },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, default: null }
  },
  data() {
    return {
      firstShow: true,
      innerVisible: false,
      filter: {
        branch: '',
        lob: '',
        customer: '',
        cargoEnglishName: '',
        mark: '',
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: event => { this.selectedRow = event.data }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'),
          field: 'cargoEnglishName',
          width: 300
        }, {
          headerName: this.$t('CargoMsg.Cargo_Marks'),
          field: 'mark',
          width: 300
        }, {
          headerName: this.$t('CargoMsg.Cargo_HsCode'),
          field: 'hsCode',
          width: 300
        }
      ],
      rowData: [],
      selectedRow: null,
      gridApi: null
    }
  },
  computed: {
    officeId() {
      return this.$store.getters.currentOfficeId
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal && this.firstShow) {
          this.firstShow = false
          this.toQuery()
        }
      }
    },
    innerVisible(newVal) {
      if (!this.innerVisible && this.gridApi) this.gridApi.clearFocusedCell()
      this.$emit('update:visible', newVal)
    },
    'job.customerId': {
      immediate: true,
      handler(newVal) {
        this.filter.customer = newVal || ''
      }
    }
  },
  methods: {
    async toQuery() {
      if (!this.job) return
      if (!this.filter.customer) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterClientName'))
        return
      }
      if (this.filter.branch !== this.officeId) {
        this.filter.branch = this.officeId
        this.pageNum = 1
      }
      this.filter.lob = this.job.lob
      const loading = getLoading4Cxt(this)
      try {
        const pageInfo = await Job.cargoDocSeaExportSearch(this.filter)
        this.rowData = pageInfo.list
        this.filter.pageNum = pageInfo.pageNum
        this.filter.pageSize = pageInfo.pageSize
        this.total = Number(pageInfo.total)
      } finally {
        loading.close()
      }
    },
    reset() {
      for (const key in this.filter) {
        if (key === 'pageNum' || key === 'pageSize') {
          continue
        }
        this.filter[key] = ''
      }
    },
    choose(fieldKeys) {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const data = {}
      for (const key of fieldKeys) {
        data[key] = this.selectedRow[key]
      }
      this.$emit('callback', data)
      this.selectedRow = null
      this.innerVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
.app-main-inner .app-main-inner-row ::v-deep {
  .el-form-item__label {
    font-size: 12px;
    font-weight: normal;
  }
}
</style>
